import React from 'react';
import GoogleLogin from '@/components/GoogleLogin';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const Login: React.FC = () => {
  const { user } = useAuth();

  if (user) {
    return <Navigate to="/" />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
        <div className="flex flex-col space-y-2 text-center">
          <h1 className="text-2xl font-semibold tracking-tight">
          </h1>
        </div>
        <GoogleLogin />
      </div>
    </div>
  );
};

export default Login;
